import { render, staticRenderFns } from "./Startpage.vue?vue&type=template&id=7e965463&scoped=true&"
import script from "./Startpage.vue?vue&type=script&lang=js&"
export * from "./Startpage.vue?vue&type=script&lang=js&"
import style0 from "./Startpage.vue?vue&type=style&index=0&id=7e965463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e965463",
  null
  
)

export default component.exports